import { ExecutedDocDropZone } from "@/components/ExecutedDocDropZone";
import { uploadExecutedWO, getExecutedWODocument } from "@/lib/api";

// Wrapper for the executed-doc drop zone on a saved WO. Stays gated
// behind `editingWO` so brand-new (unsaved) WOs never render an
// upload zone that has no entity id to attach to.
//
// Triggers a status bump to "approved" + clears `signature_required`
// when a doc is uploaded — the WO is now executed-on-file and no
// further signature prompt is needed.
//
// Extracted from WorkOrderTab.jsx (Feb 2026, iter178).
export function WOExecutedDoc({ editingWO, setForm }) {
  if (!editingWO) return null;
  return (
    <div className="border-t pt-3" data-testid="wo-executed-dropzone-section">
      <ExecutedDocDropZone
        entityId={editingWO.id}
        entityType="wo"
        executedDocument={editingWO.executed_document}
        onUpload={uploadExecutedWO}
        onViewUrl={getExecutedWODocument}
        onStatusChange={() => setForm((prev) => ({
          ...prev,
          status: "approved",
          signature_required: false,
        }))}
      />
    </div>
  );
}
